// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"YandexPayWidget_wrapper__Ehal2","card":"YandexPayWidget_card__3lHvN","split":"YandexPayWidget_split__lsLTq"};